import { randomString } from './sharedFunctions'
import { toast } from 'react-toastify'
import axios from 'axios'
import { COLLECTOR_URL, setupInterceptorsTo } from '../apiHelper/helper'
import { COLLECTOR_URL as COLLECTOR_URLs } from '../apiHelper/apiRoute/collector'
import { getImageFile, saveFilesToVisit } from '../helper/backendHelper'

export const AllowedFormats = [
  'xls',
  'xlsx',
  'xlsm',
  'xltx',
  'xltm',
  'xlsb',
  'xlam',
  'csv',
  'pdf',
  'doc',
  'docs',
  'docm',
  'dotm',
  'dotx',
  'docx',
  'xml',
  'json',
  'ppt',
  'pptx',
  'pptm',
  'potx',
  'potm',
  'ppam',
  'ppsx',
  'ppsm',
  'sldx',
  'sldm',
  'thmx',
  'mp3', // 'mp4','mov'
  'jpg',
  'jpeg',
  'png',
  'gif',
  'psd',
  'psb',
  'svg',
  'txt',
]

export const collectorApi = setupInterceptorsTo(
  axios.create({
    baseURL: COLLECTOR_URL,
  }),
)

export function filterUnwantedFiles(res, onSuccess) {
  if (res?.status === 'success') {
    if (res?.data && res.data.length > 0) {
      let files = []
      res.data.forEach((tmp) => {
        if (!tmp.isdeleted) {
          tmp.file = {
            name: tmp.file_name,
          }

          if (!tmp?.options) {
            files.push(tmp)
          }
        }
      })
      onSuccess(files)
    }
  }
}

export function uploadImage({ file, selectedProvider, onSuccess }) {
  const reader = new FileReader()
  let fileExt = file?.name?.split('.')?.pop()
  let fileName =
    selectedProvider?._id + '_' + new Date().getTime() + randomString(6) + '.' + fileExt

  if (!AllowedFormats.includes(fileExt)) {
    return toast.error('File type is not supported.')
  }

  reader.readAsDataURL(file)
  reader.onloadend = async (e) => {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('fileName', fileName)

    // TODO image is uploaded but is orphaned
    const response = await uploadImageToCensus(formData)
    if (response?.data?.status === 'success') {
      onSuccess((oldFiles) => [
        ...oldFiles,
        {
          key: fileName,
          size: file.size,
          file_type: fileExt,
          checksum: null,
          file: file,
          img: reader.result,
          status: 'uploaded',
          originalFileName: file?.name,
        },
      ])
      toast.success('Success!')
    } else {
      toast.error('Upload failed.  Please try again.')
    }
  }
}

export function viewUpload(item) {
  const link = document.createElement('a')
  link.href = item.img
  link.setAttribute('download', item?.originalFileName || item.key)
  document.body.appendChild(link)
  link.click()
}

export function onImageDownload(fileName, ogFileName, metadata = '') {
  getImageFile(fileName, metadata).then((response) => {
    const link = document.createElement('a')
    link.href = response?.data
    link.setAttribute('download', fileName || ogFileName)
    document.body.appendChild(link)
    link.click()
  })
}

export function convertAudioDumpToLocalUrl(res) {
  const [prefix, base64] = res.data.split(',')
  if (prefix && base64) {
    // Decode the base64 string
    const byteString = atob(base64)
    // Get the MIME type from the prefix
    const mimeString = prefix.split(':')[1].split(';')[0]
    // Convert binary string to Uint8Array
    const arrayBuffer = new ArrayBuffer(byteString.length)
    const uint8Array = new Uint8Array(arrayBuffer)
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i)
    }
    // Create a Blob from the Uint8Array
    const blob = new Blob([arrayBuffer], { type: mimeString })
    return URL.createObjectURL(blob)
  }
}

export async function uploadImageToCensus(fileData) {
  return await collectorApi.post(COLLECTOR_URLs.IMAGE_UPLOAD, fileData)
}

export async function uploadPatientFiles(file, { selectedProvider, patientId, chargeid }) {
  return new Promise((resolve, reject) => {
    try {
      let fileExt = file?.name?.split('.')?.pop()
      let fileName =
        selectedProvider?._id + '_' + new Date().getTime() + randomString(6) + '.' + fileExt
      if (!AllowedFormats.includes(fileExt)) {
        toast.error('File type is not supported.')
        return reject('File type is not supported.')
      }

      if (!patientId) {
        return reject('No patient id found')
      }

      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onloadend = async () => {
        let formData = new FormData()
        formData.append('file', file)
        formData.append('fileName', fileName)

        const response = await uploadImageToCensus(formData)

        if (response.status === 200) {
          await saveFilesToVisit({
            files: [
              {
                key: fileName,
                checksum: null,
                file_type: file.type,
                file_size: file.size,
                originalFileName: file.name,
                status: 'uploaded',
              },
            ],
            chargeid: chargeid,
            patient_id: patientId,
          })
          return resolve()
        }

        return reject(response)
      }
    } catch (e) {
      console.error(e)
      reject(e)
    }
  })
}
